<!-- @format -->

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
const txt = ref(null)
let props = defineProps({
  text: String,
  ellipsis: {
    type: Boolean,
    default: false,
  },
})

// let resizeOb = null;
// onMounted(() => {
//   if (props.ellipsis) {
//     const ob = new ResizeObserver((elements) => {
//       for (let entry of elements) {
//         const target = entry.target;
//         let clientWidth = target.clientWidth;
//         let minWidth = target.style.minWidth;
//         let maxWidth = target.style.maxWidth;
//         console.log(
//           `on size changed:clientWidth ${clientWidth},minWidth:${minWidth},maxWidth:${maxWidth}`
//         );
//         if (clientWidth > 0) {
//           // target.style.maxWidth = clientWidth;
//         }
//       }
//     });
//     ob.observe(txt.value);
//     resizeOb = ob;
//   }
// });
// onUnmounted(() => {
//   if (props.ellipsis && resizeOb && txt.value) {
//     resizeOb.unobserve(txt.value);
//   }
// });
</script>
<template>
  <span ref="txt" style="box-sizing: border-box" class="txt" :class="{ ellipsis: props.ellipsis }">
    <slot></slot>
    {{ text }}
  </span>
</template>
<style scoped>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.txt {
  font-size: var(--14px);
}
</style>
